import React, { useState } from 'react';
import './PlayoffsMatch.css';

import { useNavigate } from "react-router-dom";

import LogoClub from '../LogoClub';

const PlayoffsMatch = ({
    championnat,
    club,
    matchs,
    clubWinner = null,
    onlyWinner = false,
    returnMatch = true,
}) => {
    const navigate = useNavigate();

    const getResult = () => {
        let result = "";
        const matchPlayed = false; 
        const isWinner = false;

        if (matchPlayed) {
            if (isWinner) {
                result = 'winner';
            }
            else {
                result = 'looser';
            }
        }

        return result;
    }

    const formatRanking = (ranking) => {
        if (ranking === undefined) return null;
        let formatRanking = ranking;
        switch (ranking) {
            case '1':
            case 1:
                return formatRanking + "ER";
            default:
                return formatRanking + 'EME';
        }
    }

    // Redirection vers le match 
    const handleClick = (e, day, rencId) => {
        e.preventDefault();
        if (day) {
            navigate(`/${championnat}/calendrier`, { state: {
                off_down_matchs_day: day,
                off_down_matchs_id: rencId,
            }});
        }
    }

    // Fonction pour savoir si un match a débuté
    const isMatchStarted = (match) => {
        if (match === undefined || !match) return false;
        return match?.home_points !== null || match?.away_points !== null;
    }

    const getFormattedDate = (dateMatch) => {
        if (!dateMatch) return "à venir";
        const value = dateMatch;
        const date = new Date(value.split('/')[2] + '-' + value.split('/')[1] + '-' + value.split('/')[0]);
        const day = date.getDate();
        let month = date.toLocaleString('default', { month: 'long' });

        if (month.length > 4) {
            month = month.substring(0, 4) + '.';
        }

        return day + " " + month;
    }

    const getScore = (match) => {
        if (match && club) {
            const nameDom = match.domicile?.replace(/ +(?= )/g,'').trim(); // on enlève les doubles espace / AMIENS STT  1 par exemple contient deux espaces
            const nameExt = match.exterieur?.replace(/ +(?= )/g,'').trim();
            const numDom = match.clubnum_1.trim();
            const numExt = match.clubnum_2.trim();

            if (nameDom === club.title?.trim() || numDom === club.identifier?.trim()) {
                return match.home_points;
            }
            if (nameExt === club.title?.trim() || numExt === club.identifier?.trim()) {
                return match.away_points;
            }
        }
    }

    return ( 
        <div className={`playoffs_match_component playoffs_match_component_${championnat}`}>
            {!onlyWinner && (
                <span className={`playoffs_match_number ${getResult()}`}>
                    {formatRanking(club?.ranking)}
                </span>
            )}
            <div className={`playoffs_match_team ${championnat}`}>
                <span style={{
                    display: 'inline-block',
                    whiteSpace: 'nowrap', 
                    textOverflow: 'ellipsis', 
                    overflow: 'hidden',
                }}
            >
                   {clubWinner ? clubWinner?.title : club?.title}
                </span>
            </div>
            <LogoClub
                style={{backgroundColor: 'white'}}
                club={clubWinner ? clubWinner : club}
                width={64}
                height={64}
                activateLink={false}
            />
            {!onlyWinner && (
                <div className='playoffs_match_score score_aller' onClick={(e) => handleClick(e, matchs?.[0]?.day_id, matchs?.[0]?.renc_id)}>
                    {!isMatchStarted(matchs?.[0]) && (
                        <span style={{fontSize: 14, whiteSpace: "nowrap"}}>
                            {getFormattedDate(matchs?.[0]?.date)}
                        </span>
                    )}
                    {isMatchStarted(matchs?.[0]) && (
                        getScore(matchs?.[0])
                    )}
                </div>
            )}
            {!onlyWinner && returnMatch && (
                <div className='playoffs_match_score'  onClick={(e) => handleClick(e, matchs?.[1]?.day_id, matchs?.[1]?.renc_id)}>
                    {!isMatchStarted(matchs?.[1]) && (
                        <span style={{fontSize: 14, whiteSpace: "nowrap"}}>
                            {getFormattedDate(matchs?.[1]?.date)}
                        </span>
                    )}
                    {isMatchStarted(matchs?.[1]) && (
                        getScore(matchs?.[1])
                    )}
                </div>
            )}
        </div>
     );
}
 
export default PlayoffsMatch;